import styled from "styled-components";

export const CustomPageInput = styled.input`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 44px;
  width: 22px;
  text-align: center;

  &::placeholder {
    text-align: center;
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;
